module.exports = __webpack_public_path__ + "static/media/wafi-mall.ed58b762.jpeg";